<template>
	<div class="main">
		<v-card class="rounded-lg">
			<div class="before-table">
				<h1>Usuarios</h1>
				<br />

				<div class="before-table-row">
					<v-text-field
						v-model="search"
						append-icon="mdi-magnify"
						label="Buscar usuario"
						@change="fetchUsers"
					></v-text-field>
				</div>
			</div>

			<v-data-table
				:headers="headers"
				:items="users"
				class="user-list-table"
				:server-items-length="userCount"
				:page="1"
				:options.sync="options"
				:loading="loading"
				@update:options="optionsUpdate"
				:footer-props="{
					itemsPerPageOptions: [5, 10, 20],
					itemsPerPageText: 'Usuarios por página',
					pageText: `${
						1 + options.itemsPerPage * (options.page - 1)
					}-${
						options.itemsPerPage * (options.page - 1) + users.length
					} de ${userCount}`,
					showFirstLastPage: true,
				}"
				:header-props="{
					sortByText: 'Ordenar por',
				}"
			>
				<template #no-data>No hay usuarios</template>
				<template #item.verified="{ item }">
					<v-icon v-if="item.verified" color="success"
						>mdi-check</v-icon
					>
					<v-icon v-else color="error">mdi-close</v-icon>
				</template>

				<template #item.avatar="{ item }">
					<v-avatar>
						<v-img
							:src="getProfileSource(item)"
							alt="avatar"
						></v-img>
					</v-avatar>
				</template>

				<template #item.sendMsg="{ item }">
					<v-btn
						elevation="0"
						class="rounded-lg"
						color="success"
						:href="`mailto:${item.email}`"
						>Enviar mensaje</v-btn
					>
				</template>

				<template #item.banned="{ item }">
					<v-btn
						elevation="0"
						class="rounded-lg"
						color="error"
						@click="banUser(item.id)"
						v-if="!item.banned"
						>Banear</v-btn
					>
					<v-btn
						elevation="0"
						class="rounded-lg"
						color="warning"
						@click="unbanUser(item.id)"
						v-else
						>Desbanear</v-btn
					>
				</template>

				<template #item.emailVerification="{ item }">
					<v-btn
						elevation="0"
						class="rounded-lg"
						color="info"
						@click="sendEmailVerification(item.id)"
						:disabled="emailButtonLoading || item.verified"
						:loading="emailLoading === item.id"
						>Enviar verificación</v-btn
					>
				</template>
			</v-data-table>
		</v-card>
	</div>
</template>

<script>
	import axios from "axios";
	export default {
		data: () => ({
			users: [],
			options: {
				itemsPerPage: 10,
				page: 1,
				sortBy: ["name"],
				sortDesc: [true],
			},
			search: "",
			userCount: 0,

			loading: false,
			emailLoading: -1,
			emailButtonLoading: false,
			headers: [
				{
					text: "Avatar",
					value: "avatar",
					sortable: false,
					filterable: false,
				},
				{ align: "center", text: "Nombre", value: "name" },
				{ align: "center", text: "Usuario", value: "username" },
				{ align: "center", text: "Email", value: "email" },
				{ align: "center", text: "Verificado", value: "verified" },
				{
					align: "center",
					text: "Enviar mensaje",
					value: "sendMsg",
					sortable: false,
					filterable: false,
				},
				{
					align: "center",
					text: "Bloquear",
					value: "banned",
					sortable: false,
					filterable: false,
				},
				{
					align: "center",
					text: "Reenviar verificación",
					value: "emailVerification",
					sortable: false,
					filterable: false,
				},
			],
		}),
		watch: {
			options() {
				this.fetchUsers();
			},
		},
		mounted() {
			this.fetchUsers();
		},
		methods: {
			async fetchUsers() {
				try {
					this.$emit("loading", true);
					this.loading = true;
					const response = await axios.get("/admin/user-list", {
						params: {
							page: this.options.page,
							limit: this.options.itemsPerPage,
							sortBy: this.options.sortBy,
							sortDesc: this.options.sortDesc,
							search: this.search,
						},
					});

					this.users = response.data.users;
					this.userCount = response.data.userCount;
				} catch (error) {
					if (error.response && error.response.status === 401) {
						this.$router.push({ name: "AdminLogin" });
					} else {
						this.$emit("snackbar-event", {
							color: "error",
							text:
								"Ha ocurrido un error, vuelva a intentarlo más tarde",
						});
					}
				} finally {
					this.$emit("loading", false);
					this.loading = false;
				}
			},

			async banUser(userId) {
				try {
					await axios.post("/user/ban", {
						id: userId,
					});

					this.$emit("snackbar-event", {
						color: "success",
						text: "Se ha bloqueado al usuario",
					});
				} catch (error) {
					this.$emit("snackbar-event", {
						color: "error",
						text: "No se ha podido bloquear al usuario",
					});
				} finally {
					this.fetchUsers();
				}
			},

			async sendEmailVerification(userId) {
				try {
					this.emailButtonLoading = true;
					this.emailLoading = userId;
					await axios.post("/user/send-verification-email", {
						id: userId,
					});

					this.$emit("snackbar-event", {
						color: "success",
						text:
							"Se ha enviado correctamente el mensaje de verificación",
					});
				} catch (error) {
					console.error(error);
					this.$emit("snackbar-event", {
						color: "error",
						text:
							"No se ha podido enviar correctamente el mensaje de verificación",
					});
				} finally {
					this.emailButtonLoading = false;
					this.emailLoading = -1;
					this.fetchUsers();
				}
			},

			async unbanUser(userId) {
				try {
					await axios.post("/user/unban", {
						id: userId,
					});

					this.$emit("snackbar-event", {
						color: "success",
						text: "Se ha desbloqueado al usuario",
					});
				} catch (error) {
					this.$emit("snackbar-event", {
						color: "error",
						text: "No se ha podido desbloquear al usuario",
					});
				} finally {
					this.fetchUsers();
				}
			},
			getProfileSource(user) {
				return user.avatar;
			},

			optionsUpdate(e) {
				this.options = e;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.main {
		padding: 2em;
	}

	.before-table {
		padding: 2em;

		.before-table-row {
			display: flex;
			flex-wrap: wrap;
		}
	}
	.user-list {
		.v-expansion-panel-header {
			display: flex;
			flex-flow: row nowrap;
			align-items: center;

			.avatar {
				height: 48px;
				width: 48px;
				flex: initial;
				border-radius: 50%;
			}

			p {
				margin: 0 0 0 1em;
			}
		}

		.v-expansion-panel-content {
			padding: 2em 0;
			background-color: #f0f0f0;
		}
	}
</style>

<style lang="scss">
	.user-list-table {
		&.v-data-table table tbody td {
			padding: 1em !important;
		}
	}
</style>
